/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CoffeeTalkProfile = lazyLoad(
  () => import('./index'),
  module => module.CoffeeTalkProfile,
);
